import React from "react";

export interface TitleProps {
  onBulk?: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onGraph?: () => void;
  onDetails?: () => void;
  leftTitleElem?: JSX.Element;
  rightElem?: JSX.Element;
  title: string;
  number?: number;
}

/** Title bar with an optional item count and action buttons (Add, Bulk, Edit, Delete, etc.). */
const Title: React.FC<TitleProps> = ({
  onAdd,
  onEdit,
  onDelete,
  onBulk,
  onGraph,
  onDetails,
  leftTitleElem,
  rightElem,
  title,
  number,
}) => {
  return (
    <div
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      {leftTitleElem}
      <div className="card bg-light mb-3 mt-3" style={{ flexGrow: 1 }}>
        <div className="card-body p-2">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <h5 style={{ flexGrow: 1, marginLeft: 8 }}>
              {title + (number && number > 0 ? ` (${number})` : "")}
            </h5>
            {onAdd && (
              <button
                type="button"
                onClick={onAdd}
                className="mr-2 px-3 py-1.5 rounded bg-gray-900 text-white hover:bg-black"
              >
                Add
              </button>
            )}
            {onBulk && (
              <button
                type="button"
                onClick={onBulk}
                className="mr-2 px-3 py-1.5 rounded bg-gray-900 text-white hover:bg-black"
              >
                Bulk
              </button>
            )}
            {onGraph && (
              <button
                type="button"
                onClick={onGraph}
                className="mr-2 px-3 py-1.5 rounded bg-gray-900 text-white hover:bg-black"
              >
                Graph
              </button>
            )}
            {onDetails && (
              <button
                type="button"
                onClick={onDetails}
                className="mr-2 px-3 py-1.5 rounded bg-gray-900 text-white hover:bg-black"
              >
                Details
              </button>
            )}
            {onEdit && (
              <button
                type="button"
                onClick={onEdit}
                className="mr-2 px-3 py-1.5 rounded bg-gray-900 text-white hover:bg-black"
              >
                Edit
              </button>
            )}

            {onDelete && (
              <button
                type="button"
                onClick={onDelete}
                className="mr-2 px-3 py-1.5 rounded bg-red-600 text-white hover:bg-red-700"
              >
                Delete
              </button>
            )}
            {rightElem}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Title;
